import React, { useEffect, useState } from "react";
import { CustomerViewDetailsViewCustomersInfoProps } from "./campaign-view-details-view-campaigns-info.props";
import "./campaign-view-details-view-campaigns-info.scss";
import { getCustomerLeads } from "../../../../../../api/customer";
import DataTable from "../../../../../campaign/campiagn-view/campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/task-table/task-table";
import { PaginationComponent } from "../../../../../../common/components";
import { isValidPhoneNumber } from "../../../../../../utils/utils";
const CustomerViewDetailsViewLeadsInfo: React.FC<
  CustomerViewDetailsViewCustomersInfoProps
> = (props: any) => {
  const {
    selectedCustomerId,
    setLoading,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    permissions,
  } = props;
  const [leads, setLeads] = useState<any[]>([]);
  useEffect(() => {
    const fetchLeads = async () => {
      setLoading(true);
      try {
        const response = await getCustomerLeads(selectedCustomerId);
        const leads = response.data.data;
        setLeads(leads);
      } catch (error) {
        console.log("Error fetching leads:", error);
        setAlertMessage("Failed to fetch leads.");
        setAlertType("error");
        setAlertOpen(true);
      } finally {
        setLoading(false);
      }
    };
    fetchLeads();
  }, []);
  const leadColumns = [
    {
      key: "leadName",
      label: "Lead Name",
      render: (lead: any) => `${lead.name}`,
    },
    {
      key: "email",
      label: "Email",
      render: (lead: any) => lead.primaryEmail || "-",
    },
    {
      key: "source",
      label: "Lead Source",
      render: (lead: any) => lead.leadSource || "-",
    },
    {
      key: "status",
      label: "Lead Status",
      render: (lead: any) => lead.leadStatus || "-",
    },
    {
      key: "phoneNumber",
      label: "Phone Number",
      render: (lead: any) =>
        lead.primaryPhoneNumber && isValidPhoneNumber(lead.primaryPhoneNumber)
          ? lead.primaryPhoneNumber
          : "-",
    },
  ];
  return (
    <div className="campaign-view-details-view-campaigns-info">
      <div className="campaign-view-details-view-campaigns-info-header">
        <div className="campaign-view-details-view-campaigns-info-header-text">
          Leads
        </div>
      </div>

      {leads && leads.length > 0 ? (
        <div className="campaign-leads-table customer-leads-table">
          <DataTable columns={leadColumns} data={leads} />
        </div>
      ) : (
        <div className="campaign-view-details-view-campaigns-info-no-data">
          No records found.
        </div>
      )}
    </div>
  );
};

export default CustomerViewDetailsViewLeadsInfo;
